import api from "@/axios";

export default {
  findAll() {
    return api().get("trainer");
  },
  findOne(id) {
    return api().get(`admin/trainer/${id}`);
  },
  create(data) {
    return api().post("admin/trainer/add", data);
  },
  update(id, data) {
    return api().patch(`admin/trainer/${id}`, data);
  },
  remove(id) {
    return api().delete(`trainer/${id}`);
  },
};
